import dayjs from 'dayjs'
import { SHIFT, VISIT } from '../constants'
import {
  getDateTimeInZone,
  TIME_FORMAT,
  YEAR_FIRST_DATE_FORMAT
} from '../utils.datetime'

export const getRevisionFormInitialValues = (values: any) => {
  const override = values?.invoicingRateOverride
  return {
    ...values,
    slotNotes: values?.description,
    // utc() is called here to normalize antd date/time picker to understand correct behaviour, to avoid current user zone effect
    patternStart: getDateTimeInZone(values?.startTime).utc(),
    type: values?.siteShift === true ? SHIFT : VISIT,
    startTime: dayjs(values?.startTime).utc().format(TIME_FORMAT),
    endTime: dayjs(values?.endTime).utc().format(TIME_FORMAT),
    // Invoicing rate override fields
    overrideInvoicingRate: !!override,
    invoicingRateCardId:
      override?.rateCardId ??
      (override?.customRate != null ? '__custom__' : undefined),
    customInvoicingRate: override?.customRate ?? undefined
  }
}

export const getRevisionSubmitValues = (
  values: any,
  isTimeTouched?: boolean | undefined,
  isSiteShift?: boolean | undefined
) => {
  // Build invoicingRateOverride from the override form fields
  let invoicingRateOverride:
    | { rateCardId?: string; customRate?: number; unit?: string }
    | null
    | undefined
  if ('overrideInvoicingRate' in values) {
    if (!values.overrideInvoicingRate) {
      invoicingRateOverride = null // explicitly remove override
    } else if (values.invoicingRateCardId === '__custom__') {
      invoicingRateOverride = {
        customRate: values.customInvoicingRate,
        unit: 'HOUR'
      }
    } else if (values.invoicingRateCardId) {
      invoicingRateOverride = { rateCardId: values.invoicingRateCardId }
    }
    // defensive: override toggled on but no rate card resolved — should be caught by form
    // validation, but treat as no override rather than silently sending undefined
    // (invoicingRateOverride remains undefined → field omitted from payload → no change)
  }

  const transformedValues = {
    title: values?.title,
    date:
      values?.patternStart &&
      dayjs(values?.patternStart).format(YEAR_FIRST_DATE_FORMAT),
    ...(isTimeTouched &&
      values?.startTime && {
        startTime: values?.startTime
      }),
    ...(isTimeTouched &&
      values?.endTime && {
        endTime: values?.endTime
      }),
    flexiType: values?.flexiType,
    plannedDuration: values?.plannedDuration,
    addressId: isSiteShift ? undefined : values?.addressId,
    fundingTypeId: values?.fundingTypeId,
    description: values?.slotNotes,
    instanceTypeId: values?.instanceTypeId,
    ...(invoicingRateOverride !== undefined && { invoicingRateOverride })
  }

  return transformedValues
}

export const getRevisionReqFormInitialValues = (values: any) => {
  return {
    ...values,
    slotNotes: values?.description,
    type: values?.siteShift === true ? 'shift' : 'visit',
    teamMembers: values?.teamMembers?.map((member: any) => ({
      label:
        member.carer?.name?.first && member.carer?.name?.last
          ? `${member.carer.name.first} ${member.carer.name.last}`
          : undefined,
      value: member.teamMemberId || undefined
    }))
  }
}
